export const localization = {
  de: {
    settings: {
      general: 'Allgemein',
      openImage: 'Neues Bild Öffnen',
      languageHeader: 'Sprache',
      languageName: 'Deutsch',
      animDur: 'Animationslänge'
    },
    loadingError: 'Es ist ein Fehler beim laden des Bildes aufgetreten. Bitte versuche ein anderes.',
    external: 'Extern',
    measureHome: 'https://www.structem.de/measure',
    measureLogo: './assets/standard-logo.svg',
    magnification: (val: number) => `Vergrößerung: ${val}x`,
    overlayScale: 'Skalierung',
    quickInstruction: 'Klicke auf das Bild um eine neue Messung zu starten',
    quickOpen: 'Klicke hier um ein neues Bild zu öffnen',
    measurements: {
      title: 'Messen',
      name: 'Messungen',
      pixelLength: 'Pixel Länge',
      imageWidth: 'Bild Breite',
      imageHeight: 'Bild Höhe',
      defaultName: 'Messung',
      length: 'Länge',
      area: 'Fläche',
      circumference: 'Umfang',
      pixelUnit: 'pixel',
      imageInfo: 'Bild Information'
    },
    settingsTitle: 'Einstellungen',
    filterTitle: 'Filter',
    filterReset: 'Alle Zurücksetzen',
    startNewMessage: 'Klicke hier oder Drag & Drop ein Bild irgendwo in der App um eine neue Messung zu starten',
    deleteJointMessage: 'Gelenk Entfernen (greifen + entf)',
    insertJointMessage: 'Gelenk Hinzufügen (greifen + ziehen)',
    saveDialog: {
      saveImage: 'Bild Speichern',
      saveCsv: 'CSV Speichern',
      filename: 'Dateiname',
      save: 'Speichern',
      cancel: 'Abbrechen'
    },
    openDialog: {
      openImage: 'Bild Öffnen'
    },
    usedLibs: 'Benutzte Bibliotheken',
    by: (title: string, author: string) => `${title} von ${author}`,
    developed: 'Entwickelt',
    disclaimer: 'Haftungsausschluss',
    disclaimerText: `
      strucTEM Measure wird von strucTEM "as is" und ungeachtet irgendwelcher Fehler bereitgestellt.
      strucTEM gibt keine Garantien oder Gewährleistungen irgendwelcher Art bezüglich Sicherheit,
      Eignung, Ungenauigkeit, typographischer Fehler oder anderer unerwünschter Komponenten von strucTEM Measure.
    `,
    imageDisclaimer: 'Bildrechte & Lizenzen',
    imageDisclaimerText: `
      Das Urheberecht aller Mikroskopie-Bilder liegt bei strucTEM.
      Die Bilder und gespeicherte Teilbereiche dürfen für den privaten Zweck verwendet werden.
      Für alle weiteren Anwendungen bitte direkt an "kontakt @ structem.de" wenden.
    `,
    imprint: 'Impressum',
    imprintLink: 'https://www.structem.de/impressum/',
    privacyPolicy: 'Datenschutzerklärung',
    privacyPolicyLink: 'https://www.structem.de/datenschutzerklaerung/',
    tooltips: {
      random: 'Wähle zufälliges Bild',
      save: 'Speichern',
      zoomToggle: 'Bild Einpassen/Originalgröße',
      zoomIn: 'Zoom Vergrößern (Strg + Mausrad über dem Bild)',
      zoomChange: 'Ändere Zoom (Strg + Mausrad über dem Bild)',
      zoomOut: 'Zoom Verkleinern (Strg + Mausrad über dem Bild)',
      deleteMeasurements: 'Lösche alle Messungen',
      openImage: 'Neues Bild öffnen',
      openImageCateg: (cName: string) => `Neues Bild von ${cName} öffnen`,
      resetSettings: 'Alle Einstellungen Zurücksetzen',
      resetSingleFilter: (fName: string) => `${fName} Zurücksetzen`,
      resetFilters: 'Alle Filter Zurücksetzen',
      deleteSingleMeasurement: (mName: string) => `Lösche ${mName}`,
      toggleShowMeasurement: (mName: string) => `Zeige/Verstecke ${mName}`,
      about: 'Über strucTEM Measure',
      tools: {
        SingleLine: 'Einfache Längenmessung',
        LineStrip: 'Komplexe Längenmessung',
        Polygon: 'Flächenmessung'
      }
    }
  },
  en: {
    settings: {
      general: 'General',
      openImage: 'Open New Image',
      languageHeader: 'Language',
      languageName: 'English',
      animDur: 'Animation Duration'
    },
    loadingError: 'There was an error while loading the image. Please try another.',
    external: 'External',
    measureHome: 'https://www.structem.eu/measure',
    measureLogo: './assets/standard-logo.svg',
    magnification: (val: number) => `Magnification: ${val}x`,
    overlayScale: 'Overlay Scale',
    quickInstruction: 'Click anywhere on the image to start a new Measurement',
    quickOpen: 'Click here to open a new image',
    measurements: {
      title: 'Measure',
      name: 'Measurements',
      pixelLength: 'Pixel Length',
      imageWidth: 'Image Width',
      imageHeight: 'Image Height',
      defaultName: 'Measurement',
      length: 'Length',
      area: 'Area',
      circumference: 'Circumf.',
      pixelUnit: 'pixel',
      imageInfo: 'Image Info'
    },
    settingsTitle: 'Settings',
    filterTitle: 'Filter',
    filterReset: 'Reset All',
    startNewMessage: 'Click/Tap here or drop an image anywhere to start a new measurement',
    deleteJointMessage: 'Delete Joint (grab + del)',
    insertJointMessage: 'Insert Joint (grab + drag)',
    saveDialog: {
      saveImage: 'Save Image',
      saveCsv: 'Save CSV',
      filename: 'Filename',
      save: 'Save',
      cancel: 'Cancel'
    },
    openDialog: {
      openImage: 'Open Image'
    },
    usedLibs: 'Used Libraries',
    by: (title: string, author: string) => `${title} by ${author}`,
    developed: 'Developed',
    disclaimer: 'Disclaimer',
    disclaimerText: `
      srucTEM Measure is provided by strucTEM "as is" and "with all faults".
      strucTEM makes no representations or warranties of any kind concerning the safety,
      suitability, inaccuracies, typographical errors, or other unwanted components of strucTEM Measure.
    `,
    imageDisclaimer: 'Image rights & licenses',
    imageDisclaimerText: `
      The copyright of all microscopy images is held by strucTEM.
      The images and stored parts of the images may be used for private purposes.
      For all other applications please contact "contact @ structem.de".
    `,
    imprint: 'Imprint',
    imprintLink: 'https://www.structem.eu/imprint/',
    privacyPolicy: 'Privacy Policy',
    privacyPolicyLink: 'https://www.structem.eu/privacy-policy-2/',
    tooltips: {
      random: 'Choose random image',
      save: 'Save',
      zoomToggle: 'Toggle Fit/Original Size',
      zoomIn: 'Zoom In (Ctrl + Mousewheel over image)',
      zoomChange: 'Change Zoom (Ctrl + Mousewheel over image)',
      zoomOut: 'Zoom Out (Ctrl + Mousewheel over image)',
      openImage: 'Open new Image',
      openImageCateg: (cName: string) => `Open new Image from ${cName}`,
      resetSettings: 'Reset all Settings',
      resetFilters: 'Reset all Filters',
      resetSingleFilter: (fName: string) => `Reset ${fName}`,
      deleteMeasurements: 'Delete all measurements',
      deleteSingleMeasurement: (mName: string) => `Delete ${mName}`,
      toggleShowMeasurement: (mName: string) => `Show/Hide ${mName}`,
      about: 'About strucTEM Measure',
      tools: {
        SingleLine: 'Simple Length-Measurement',
        LineStrip: 'Complex Length-Measurement',
        Polygon: 'Area-Measurement'
      }
    }
  }
};